<template>
  <div class="campaigns-confirmation-popup">
    <vs-popup class="holamundo campaigns-confirmation" :active="show" :buttons-hidden="true">
      <div class="prompt-title mb-2">
        <vs-icon class="block-confirmation-popup" icon="speakol-help" icon-pack="speakol"></vs-icon>
        <span class="confirmation-title">Confirmation</span>
      </div>

      <div class="prompt-body mb-10 mt-4">
        <p class="block-confirmation-desc">
          Are you sure you want to block <strong class="website-name">{{ boldText }}</strong> website{{ Number.isInteger(boldText) && boldText > 1 ? 's' : '' }}?
        </p>

        <p class="block-confirmation-note">
          *Please note that any changes you make will reflect on {{ campaigns.length }} of your running campaigns.
        </p>
      </div>

      <div class="prompt-table">
        <ul class="campaigns-list">
        <blockquote>
          <li v-for="(c, index) in campaigns" :key="index">
            <span class="popup-campagin-name">{{ c.name }}</span>
          </li>
        </blockquote>
        </ul>
      </div>

      <div class="flex flex-wrap mt-10 md:justify-end btns">
        <!-- Confirm Button -->
        <!-- <speakol-main-button class="ml-4 w-full" @click.native="confirm" mainAction = 'true' :buttonText = "'Confirm'"></speakol-main-button> -->
        <vs-button @click="confirm" class="font-medium w-full ok-btn mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last">
          Block
        </vs-button>

        <!-- No Button -->
        <vs-button
          class="font-medium no-shadow w-full cancel-btn md:cancel-btn"
          type="border"
          text-color="#2C2C2C"
          color="#D9D9D9"
          @click="hide"
        >
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import SpeakolMainButton from '@/components/speakol-template/SpeakolMainButton.vue'

export default {
  props: {
    campaigns: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    boldText: {
      default: ''
    }
  },
  components: {
    SpeakolMainButton
  },
  methods: {
    hide () {
      this.$emit('hide')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
/deep/ .con-vs-popup /deep/ .vs-popup--content {
  padding: 51px 51px 51px 56px;
}

/deep/ .con-vs-popup /deep/ .vs-popup {
  border-radius: 16px !important;
}

.popup-campagin-name {
  font-weight: 500;
}

.btns button {
  border-radius: 3px;
  height: 40px;

  .cancel-btn {
    background: #fff;
  }
}

.ok-btn {
  background: #0092d7 !important;
  width: 185px !important;
}

.ok-btn:hover {
  box-shadow: none !important;
}

.prompt-title {
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 40px;
  color: #2c2c2c;
}

.prompt-body {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #999;
}

/deep/ .vs-popup {
  width: 893px;
  height: 456px;
}

.block-confirmation-popup {
  color: white;
  background-color: #faad14;
  border-radius: 100%;
  padding: 5px 5px;
  position: relative;
  top: 2px;
}

.block-confirmation-desc {
  color: rgba(0, 0, 0, 0.65);
}

.confirmation-title {
  font-weight: 500;
  font-size: 24px;
  margin-left: 20px;
}

.block-confirmation-note {
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 20px;
}

.campaigns-list {
  max-height: 184px;
  overflow-y: scroll;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 20px;
  list-style: inherit;

  li {
    word-break: break-all;
    width: 420px;
    line-height: 35px;
    color: rgba(0, 0, 0, 0.65);
    margin-left: 20px;
  }

  li::marker {
    font-size: 16px;
    margin-left: 20px;
  }
}

/deep/ .vs-switch-primary {
  background-color: red;
}

.website-name {
  word-break: break-all;
}

@media (min-width: 768px) {
  .md\:cancel-btn {
    min-width: 112px !important;
    max-width: 140px;
  }
}

@media (max-width: 576px) {
  .ok-btn {
    width: 100% !important;
  }

  .campaigns-list {
    li {
      word-break: break-all;
      width: 230px;
    }
  }

  /deep/ .con-vs-popup /deep/ .vs-popup--content {
    padding: 31px 31px 31px 36px;
  }
}
</style>
